var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidgetChartLineBlue = function SvgWidgetChartLineBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    d: "M3 5v14a1.5 1.5 0 0 0 1.5 1.5H21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m6.5 14.5 4-5 3.5 3 4.5-6"
  })));
};
export { SvgWidgetChartLineBlue as ReactComponent };
export default __webpack_public_path__ + "ea42cc854e474512ec4a6c2721f2adb0.svg";